import React from 'react';

interface CouriersIconProps {
    className?: string;
    size?: number;
}

/**
 * Ícono de "Couriers/Mensajería"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Un camión de reparto/courier
 * - Representa servicios de mensajería y envío
 * - Estilo minimalista, líneas limpias
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const CouriersIcon: React.FC<CouriersIconProps> = ({
    className = '',
    size = 150,
}) => {
    return (
        <svg
            width={size}
            height={(size * 100) / 150}
            viewBox="0 0 150 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Cuerpo principal del camión */}
            <rect x="10" y="30" width="80" height="40" rx="4" fill="currentColor" opacity="0.2" />

            {/* Cabina del camión */}
            <path
                d="M90 30H120L135 50V70H90V30Z"
                fill="currentColor"
                opacity="0.3"
            />

            {/* Ventana de la cabina */}
            <rect x="95" y="35" width="20" height="20" rx="2" fill="currentColor" opacity="0.5" />

            {/* Ruedas */}
            <circle cx="30" cy="75" r="12" fill="currentColor" opacity="0.4" />
            <circle cx="30" cy="75" r="6" fill="currentColor" />

            <circle cx="110" cy="75" r="12" fill="currentColor" opacity="0.4" />
            <circle cx="110" cy="75" r="6" fill="currentColor" />

            {/* Detalles del paquete en el cuerpo */}
            <rect x="20" y="40" width="30" height="20" rx="2" fill="currentColor" opacity="0.4" />
            <line x1="35" y1="40" x2="35" y2="60" stroke="currentColor" strokeWidth="2" opacity="0.6" />
            <line x1="20" y1="50" x2="50" y2="50" stroke="currentColor" strokeWidth="2" opacity="0.6" />
        </svg>
    );
};

